import { ReactNode } from 'react';
import { Navigate } from 'react-router-dom';
import { ROUTES } from '../../utils/constants/routes';
import { useAuthStore } from '../../stores/authStore';

interface AuthGuardProps {
  children: ReactNode;
}

/**
 * AuthGuard component to protect routes
 * @param param Children
 * @returns
 */
const AuthGuard = ({ children }: AuthGuardProps) => {
  const { isAuthenticated } = useAuthStore();

  // If routes are in the privatePaths list and isAuthenticated === false then kick out login. Otherwise go to Not-Found page
  if (!isAuthenticated) {
    return <Navigate to={ROUTES.LOGIN} replace />;
  }

  return <>{children}</>;
};

export default AuthGuard;
